<template>
  <div class="knd-map">

    <div class="knd-loader" v-if="!mapLoaded"></div>
    <l-map
      ref="leafletmap"
      :options="{ preferCanvas: true, gestureHandling: true, zoomControl: false }"
      @ready="mapReady"
    >

    <l-tile-layer :url="tileLayer.url" :attribution="tileLayer.attribution" :maxZoom="tileLayer.maxZoom"></l-tile-layer>
    
        <QuoteMarkers />
        
        <CanvasMarkers />
        <!-- <l-tile-layer :url="CartoDB_PositronOnlyLabels.url" :attribution="CartoDB_PositronOnlyLabels.attribution" :maxZoom="CartoDB_PositronOnlyLabels.maxZoom"></l-tile-layer> -->
    </l-map>

  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';

import { LMap, LTileLayer } from '@vue-leaflet/vue-leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { GestureHandling } from "leaflet-gesture-handling";

import CanvasMarkers from './markers.vue';
import QuoteMarkers from './quote-markers.vue';

import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import 'leaflet-geosearch/dist/geosearch.css';
import 'leaflet/dist/leaflet.css';

import { useStore } from 'vuex';

const store = useStore();
let leafletMap = undefined;


let mapLoaded = ref(false);

const provider = new OpenStreetMapProvider({
  params: {
    'accept-language': 'nl', 
    countrycodes: 'nl'
  }
});

const searchControl = new GeoSearchControl({
  provider: provider,
  style: 'bar', // optional: bar|button  - default button
  autoCompleteDelay: 250,
  notFoundMessage: 'Sorry, het adres kon niet worden gevonden.',
  showMarker: false,
  searchLabel: 'Zoek op gemeente, plaats, adres',
});

store.watch((state, getters) => getters.featured, (a, oldvalue)=>{
  if(!a) return;

  let lat = +a['Latitude'];
  let lng = +a['Longitude'];

  if(!leafletMap || !lat) return;
  let isInView = leafletMap.getBounds().contains([lat, lng]);
  
  if(isInView) {
    leafletMap.setView([lat, lng], 16);
  } else {
    leafletMap.flyTo([lat, lng], 16);
  }

  // leafletMap.setView([lat, lng], 16);

})

const tileLayerOption = {
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
  attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
  maxZoom: 16,
};

const tileLayer = {
  url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
  maxZoom: 20,
  subdomains: 'abcd'
};

var CartoDB_PositronOnlyLabels = {
  url: 'https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png',
	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
	subdomains: 'abcd',
	maxZoom: 20
};


const mapReady = (map) => {
  leafletMap = map;
  // map.whenReady(() => map.gestureHandling?._handleMouseOver?.());
  mapLoaded.value = true;

  leafletMap.on("moveend", function () {
    leafletMap.gestureHandling?._handleMouseOver?.();
  });



  let bounds = [[53.503377, 3.564140], [ 50.811807018028695, 7.184134543052038]]
  map.fitBounds(bounds)

  map.addControl(searchControl);
};

function fixBug() {
  window.dispatchEvent(new Event('resize'));
}

onMounted(() => {
  const observer = new IntersectionObserver(fixBug);
  if (leafletMap) {
    observer.observe(leafletMap.$el);
  }
});
</script>

<style lang="scss">
.knd-map {
  height: 100%;
  width: 100%;
}

.leaflet-control-geosearch {
  .results {
    font-size: 14px;
  }
}
</style>